import { createDemoSourcePort } from '#shared';

import type { CaseTrackingResponse } from '../model';

export type DemoTrackingSource = (nowMs: number) => CaseTrackingResponse;

const port = createDemoSourcePort<DemoTrackingSource>();

export const registerDemoTrackingSource = port.register;
export const loadDemoTrackingSource = port.load;
